import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OrganizationState {
  logoUrl: string | null;
}

const initialState: OrganizationState = {
  logoUrl: null,
};

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setLogoUrl: (state, action: PayloadAction<string | null>) => {
      state.logoUrl = action.payload;
    },
  },
});

export const { setLogoUrl } = organizationSlice.actions;
export default organizationSlice.reducer; 